<template>
    <div class="container" style="max-width: 72rem;">
        
        <div v-if="success"  class="vh-100 bg-white shadow-sm d-flex justify-content-center">
            <div class="d-flex flex-column justify-content-center align-items-center my-auto -mt-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="70" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mb-1 text-primary">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>                  
                <div class="d-flex flex-column justify-content-center align-items-center text-muted mb-3">
                    <div>
                        Obrigado, sua assinatura
                    </div>
                    <div>foi alterada com sucesso!</div>
                </div>
                <a class="btn btn-primary" href="/teacher/dashboard">
                    Voltar para o Início
                </a>
            </div>
        </div>

        <b-card v-else class="d-flex flex-column">
            <div class="mb-3 h3">Assinatura</div>
            <div>
                <b-form-group
                id="payment_method"
                label="Metódo de  Pagamento"
                description="Selecione o método de pagamento para seu plano."
                >
                    <b-form-select v-model="selected_payment_method" class="">
                        <b-form-select-option v-for="method in paymentMethods" :key="method.id" :value="method.id">{{method.card.brand}} - {{method.card.last4}} {{ method.card.exp_month }}/{{ method.card.exp_year }}</b-form-select-option>
                    </b-form-select>

                    <has-errors :errors="errors" name="default_payment_method" />
                </b-form-group>
            </div>
            <b-form-group
            label="Endereço de cobrança"
            description="Endereço necessario para faturamento da sua assinatura"
            >
                <address-form ref="addressForm" :showButton="false" :address="address" :errors="errors"/>
            </b-form-group>

            <b-form-group
            id="plan"
            label="Planos"
            description="Escolha seu plano de acordo com a quantidade de alunos."
            >
                <div class="d-flex justify-content-center gap-3 w-100 flex-wrap">
        
                    <div class="plan-card" v-for="plan in plans" :key="plan.id">
                        <b-card class="h-100 shadow" :class="selected_plan?.id === plan.id && 'border border-primary'" style="border-radius: 10px;">
                            <div class="h-100 relative d-flex flex-column align-items-center">

                                <div v-if="plan.default_price.id === actualSubscriptionPrice" class="badge badge-pill badge-primary absolute">
                                    Plano Atual
                                </div>
                                <div class="font-weight-bolder h4 my-3">
                                    {{ plan.name }}
                                </div>
                                <div class="h3 text-primary font-weight-bolder my-3" v-if="plan.default_price.tiers_mode === 'volume'">
                                    R${{ Number(plan.default_price.tiers[0].unit_amount/100).toLocaleString('pt-br') }}
                                    <span class="text-muted h5"> Por Aluno</span>
                                </div>
                                <div class="h3 text-primary font-weight-bolder my-3" v-else >
                                    R${{ Number(plan.default_price.unit_amount/100).toLocaleString('pt-br') }}
                                    <span class="text-muted h5"> Por Aluno</span>
                                    <!-- <span v-if="plan.default_price.recurring.interval === 'month'" class="text-muted h-5">/Mês</span> -->
                                </div>
                                <div v-if="plans_details.find(detail => plan.id === detail.product)">
                                    <div class="text-muted" v-if="plans_details.find(detail => plan.id === detail.product).range.min">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-primary">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                          </svg>
                                          
                                        A partir de {{ plans_details.find(detail => plan.id === detail.product).range.min }}
                                    </div>
                                    <div class="text-muted" v-if="plans_details.find(detail => plan.id === detail.product).range.max">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-primary">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                          </svg>
                                          
                                        Até {{ plans_details.find(detail => plan.id === detail.product).range.max }}
                                    </div>
                                </div>
                                <b-input-group class="my-3" :hidden="selected_plan?.id != plan.id">
                                    <b-input-group-prepend>
                                      <b-button variant="outline-secondary" @click="quantity--">-</b-button>
                                    </b-input-group-prepend>
                                    <b-form-input type="number" v-model="quantity"></b-form-input>
                                    <b-input-group-append>
                                      <b-button variant="outline-secondary" @click="quantity++">+</b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <div class="mt-auto mb-0 w-100">
                                    <button 
                                    type="button" 
                                    @click="selected_plan = plan" 
                                    style="border-radius: 5px;" 
                                    :class="selected_plan?.id === plan.id ? 'btn btn-block  btn-primary' : 'btn btn-block btn-light' "
                                    >
                                        {{ selected_plan?.id === plan.id ? 'Selecionado' : 'Selecionar' }}
                                    </button>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>

                <has-errors :errors="errors" name="product_price" />
            </b-form-group>
            <b-form-group
            label-cols="4"
            label="Cupom de desconto"
            >   
                <b-input-group>
                    <b-form-input v-model="coupon_id" placeholder="possui um cupom de desconto?"/>
                    <b-input-group-append>
                        <button :disabled="!coupon_id" @click="verifyDiscountCoupons" class="btn btn-primary">
                            Validar
                        </button>
                    </b-input-group-append>
                </b-input-group>

                <has-errors :errors="errors" name="coupon" />
            </b-form-group>
            <div class="my-3">
                <div>
                    <div v-if="quantity>0">{{ selected_plan?.name }} - {{ quantity }} x R${{ Number(this.unit_price/100).toLocaleString('pt-br') }}</div>
                    <div v-if="coupon">Cupom <b>{{ coupon.name }}</b> - {{ coupon.amount_off ?  'R$'+coupon.ammount_off : coupon.percent_off+'%' }} </div>
                </div>
                <div class=" d-flex justify-content-between h-4 font-weight-bolder ">
                    <div>
                        Valor total da assinatura
                    </div>
    
                    <div class="h4">R${{ total }}</div>
                </div>
                
            </div>
            <button @click="checkout" :disabled="loading" style="border-radius: 5px;" class="btn btn-block" :class="selected_plan ? 'btn-success' : 'btn-primary'">
                <span v-if="!loading">Assinar</span>
                <b-spinner v-else small label="Loading..."></b-spinner>
            </button>
        </b-card>

        
    </div>
</template>

<script>
import AddressForm from '../../../../components/AddressForm.vue';
export default {
    components: { AddressForm },
    props: {
        plans: {
            type: Array,
            default: [],
        },

        plans_details: {
            type: Array,
            default: [],
        },

        paymentMethods: {
            type: Array,
            default: [],
        },
        actualSubscriptionPrice: {
            default: null
        },
        address: {
            type: Object,
            default: {
                street: null,
                zip_code: null,
                state: null,
                city: null,
                number: null,
                country: 'BR'
            },
            
        },
    },
    
    watch: {
        quantity(value) {
            this.verifyRangeValues(value);
            this.calcTotal();
        },
        selected_plan(){
            const price = this.selected_plan?.default_price;
            this.unit_price = price.tiers_mode === 'volume' ? price.tiers[0].unit_amount : price.unit_amount
            this.verifyRangeValues(this.quantity);
        },
        coupon(){
            this.calcTotal()
        }
    },

    data () {
        return {
            errors: {},
            quantity: 0,
            selected_payment_method: this.paymentMethods.length > 0 ? this.paymentMethods[0].id : null,
            selected_plan: null,
            total: 0,
            unit_price: 0,
            loading: false,
            success: false,
            coupon: null,
            coupon_id: null
        }
    },

    created () {
        
    },
    methods: {
        checkout(){
            this.loading = true
            const address =  this.$refs.addressForm.form;

            axios.post('/teacher/subscription/create', {
                product: this.selected_plan,
                product_price: this.selected_plan?.default_price.id,
                quantity: this.quantity,
                default_payment_method: this.selected_payment_method,
                coupon_id: this.coupon?.id, 
                street: address?.street,
                zip_code: address?.zip_code,
                number: address?.number,
                city: address?.city,
                state: address?.state,
                country: 'BR',

            })
            .then((result) => {
                this.$toast.success('Assinatura alterada com sucesso!');
                this.success = true;
                this.errors = {}

            }).catch((err) => {
                this.errors = this.setErrors(err)
            }).finally(() => this.loading = false );
        },

        verifyRangeValues(value){
            const detail = this.plans_details.find((plan) => plan.product === this.selected_plan?.id);
            if(detail){
                if(detail?.range.min && value < detail?.range.min){
                    this.quantity = detail.range.min
                }

                if(detail?.range.max && value > detail?.range.max){
                    this.quantity = detail.range.max
                }
            }
        },
        
        preventOutRangeValues(event){
            const detail = this.plans_details.find((plan) => plan.product === this.selected_plan?.id);
            if(detail){
                if(detail?.range.min && Number(event.key) < detail?.range.min){
                    event.preventDefault();
                }

                if(detail?.range.max && Number(event.key) > detail?.range.max){
                    event.preventDefault();
                }
            }
        },

        verifyDiscountCoupons(){
            axios.get('/teacher/subscription/plans/coupon?coupon_id=' + this.coupon_id).then((result) => {
                const response = result.data.data
                this.$toast.success(response.message);
                this.coupon = response.coupon
            }).catch((err) => {
                this.errors = err ? this.setErrors(err) : {...this.errors, coupon: ['Cupon inválido']}
            });
        },

        calcTotal(){
            const subscriptionTotal = Number((this.unit_price) * this.quantity/100);
            let discounts = 0

            if(this.coupon && subscriptionTotal){
                if(this.coupon.amount_off){
                    discounts = subscriptionTotal - this.amount_off
                }
                if(this.coupon.percent_off){
                    discounts = subscriptionTotal * this.coupon.percent_off/100
                }

            }

            this.total = Number(subscriptionTotal - discounts).toLocaleString('pt-br');
        }
    }
}
</script>

<style>
    .plan-card {
        flex: 1 1 275px;
        min-height: 300px;
        border-radius: 10px;
        background-color: white;
    }
</style>